import { useState, useEffect, useCallback } from "react";
import SidePanel from "./sidepane/SidePanel";

import Legend from "./Legend";
import RightBar from "./RightBar";
import FooterGeoportal from "./sidepane/FooterGeoportal";
import Map from "./map";
import "./styles/GeoportalStyle.css";
// import Position from "rsuite/esm/Overlay/Position";
import axios from "axios";
import ReactGA from "react-ga4";

import { handle_legend_url } from "./sidepane/Precipitation";

export const TRACKING_ID = "G-4L6WN78NLS";


export const base_url = "https://ada.acmad.org";  //"http://localhost"
export const geoserver = `${base_url}/geoserver/wms?`;
export const maplibre_str =
  "bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&width=256&height=256&transparent=true&layers=";

export const get_data = async (url) => {
  const res = await axios.get(url);

  const data = res.data;

  return data;
};
ReactGA.initialize(TRACKING_ID);
const Geoportal = () => {
  const [sidebarOpen, setSidebarOpen] = useState(
    typeof window !== "undefined" && window.innerWidth > 1024
  );
  const [rightBarOpen, setRightBarOpen] = useState(
    typeof window !== "undefined" && window.innerWidth > 1024
  );

  const [cdi_selected_dates, setCdi_selected_dates] = useState({
    year: 2020,
    month: "Aug",
    dekad: "3rd",
  });

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "geoportal",
    });
  }, []);

  const [current_cdi, setCurrent_cdi] = useState(null);
  const [cdi_check, setCdi_check] = useState(true);
  const [current_cdi_era5, setCurrent_cdi_era5] = useState(null);
  const [cdi_era5_check, setCdi_era5_check] = useState(false);
  const [drought_persistence_check, setDrought_persistence_check] = useState(false);
  const [current_drought_persistence, setCurrent_drought_persistence] = useState(null);
  const [countries_options, setCountries_options] = useState({});
  const [selected_country, setSelected_country] = useState(null);
  const [selected_region, setSelected_region] = useState(null);
  const [rs_data, setRs_data] = useState(null);
  const [precipitation_check, setPrecipitation_check] = useState(false);
  const [current_vector, setCurrent_vector] = useState(null);
  const [current_spi, setCurrent_spi] = useState(null);
  const [current_fapar_anomaly, setCurrent_fapar_anomaly] = useState(null);
  const [spi_legend_url, setSpi_legend_url] = useState(null);
  const [fapar_anomaly_legend_url, setFapar_anomaly_legend_url] =
    useState(null);
  const [fapar_anomaly_check, setFapar_anomaly_check] = useState(false);
  const [fapar_absorbed_check, setFapar_absorbed_check] = useState(false);
  const [fapar_absorbed_legend_url, setFapar_absorbed_legend_url] =
    useState(null);
  const [current_fapar_absorbed, setCurrent_fapar_absorbed] = useState(null);
  // precipitation props

  const [monthly_precipitation_check, setMonthly_recipitation_check] =
    useState(false);

  const [
    gpcc_monthly_precipitation_legend_url,
    setGpcc_monthly_precipitation_legend_url,
  ] = useState(null);

  const [
    current_monthly_precipitation_gpcc,
    setCurrent_monthly_precipitation_gpcc,
  ] = useState(null);

  const [unwdc_check , setUnwdc_check] = useState(false);
  const [current_unwdc , setCurrent_unwdc] = useState(null);
  const [unwdc_legend_url , setUnwdc_legend_url] = useState(null);
  const [spi_era5_current, setCurrent_spi_era5] = useState(null);

  const [checked_spi_era5, setChecked_spi_era5] = useState(false);

  // soil props
  const [sma_check, setSma_check] = useState(false);
  const [current_sma, setCurrent_sma] = useState(null);
  const [legend_url_sma, setLegend_url_sma] = useState(null);
  // ndvi props
  const [request_str_modis_ndvi, setRequest_str_modis_ndvi] = useState(null);
  const [current_ndvi, setCurrent_ndvi] = useState(null);

  const [ndvi_check, setNdvi_check] = useState(false);
  const [koppen_climate_clas_check, setKoppen_climate_clas_check] =
    useState(false);

  const [active_admin_boundaries, setActive_admin_boundaries] = useState(true);

  const [current_protected_areas, setCurrent_protected_areas] = useState(null);
  const [protetect_areas_check, setProtetect_areas_check] = useState(false);

  // Combined monitoring & forecast hazard indicator (S = cdi_tier + forecast),
  // one toggle per CDI reference source -- same era5/gpcc pairing already
  // used for spi/spi_era5, cdi/cdi_era5 elsewhere in this file.
  const [current_combined_hazard_era5, setCurrent_combined_hazard_era5] = useState(null);
  const [combined_hazard_era5_check, setCombined_hazard_era5_check] = useState(false);
  const [current_combined_hazard_gpcc, setCurrent_combined_hazard_gpcc] = useState(null);
  const [combined_hazard_gpcc_check, setCombined_hazard_gpcc_check] = useState(false);

  // Combined ACMAD x UNWDC signed forecast -- same era5/gpcc pairing, same category.
  const [current_combined_forecast_era5, setCurrent_combined_forecast_era5] = useState(null);
  const [combined_forecast_era5_check, setCombined_forecast_era5_check] = useState(false);
  const [current_combined_forecast_gpcc, setCurrent_combined_forecast_gpcc] = useState(null);
  const [combined_forecast_gpcc_check, setCombined_forecast_gpcc_check] = useState(false);

  const [active_tab, setActive_tab] = useState("Legend");
  const [clicked_latlong, setClicked_latlong] = useState(null);
  const [pixelDataFetched, setPixelDataFetched] = useState(false);

  const [admin_details, setAdmin_details] = useState({});
  const [show_generate_report, setShow_generate_report] = useState(false);

  // longrange forecast props
  // const [longrange_forecast_legend_url, setLongrange_forecast_legend_url] = useState(null);
  const [longrange_forecast_check, setLongrange_forecast_check] = useState(false);
  const [current_longrange_forecast, setCurrent_longrange_forecast] = useState(null);

  // Per-layer opacity (0–1); keyed by the opacity key used in Legend and map.js
  const [layerOpacity, setLayerOpacity] = useState({
    cdi: 1, unwdc: 1, spi: 1, faparAnom: 1, faparAbsorbed: 1,
    monthly_precipitation_gpcc: 1, sma: 1, koppen_climate: 1,
    spi_era5: 1, drought_persistence: 1, longrange_forecast: 1, ndvi: 1,
  });
  const handleOpacityChange = useCallback((key, value) => {
    setLayerOpacity((prev) => ({ ...prev, [key]: value }));
  }, []);





  // var geoserver = `${base_url}/geoserver/wms?`;
  const layer_name_kopen_climate =
    "africa_drought_datasets:koppen_classification_compreesed";
  const koppen_classification_url = `${geoserver}${maplibre_str}${layer_name_kopen_climate}`;
  const leged_url_koppen = handle_legend_url(
    layer_name_kopen_climate,
    geoserver,
    true
  );
  const [koppen_climate_url] = useState({
    geoserver: koppen_classification_url,
    leged_url: leged_url_koppen,
  });

  useEffect(() => {
    const get_rs_data = async () => {
      const rs_data = await get_data(
        `${base_url}/api/data_api/rs_data/get_available_datasets`
      );
      setRs_data(rs_data);
    };
    get_rs_data();
  }, []);


  const now = new Date();

  const lastUpdated = now.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    // day: "numeric",
  });

  const year = now.getFullYear();

  return (
    <div className={`geoportal${sidebarOpen ? " sidebar-open" : ""}`}>
      {/* Mobile sidebar toggle */}
      <button
        className="sidebar-toggle"
        onClick={() => setSidebarOpen((v) => !v)}
        aria-label={sidebarOpen ? "Close sidebar" : "Open sidebar"}
      >
        {sidebarOpen ? "\u2715" : "\u2630"}
      </button>
      <SidePanel
        countries_options={countries_options}
        setCountries_options={setCountries_options}
        selected_country={selected_country}
        setSelected_country={setSelected_country}
        rs_data={rs_data}
        precipitation_check={precipitation_check}
        setPrecipitation_check={setPrecipitation_check}
        setCurrent_vector={setCurrent_vector}
        setCurrent_spi={setCurrent_spi}
        setSpi_legend_url={setSpi_legend_url}
        current_spi={current_spi}
        setCurrent_fapar_anomaly={setCurrent_fapar_anomaly}
        current_fapar_anomaly={current_fapar_anomaly}
        fapar_anomaly_check={fapar_anomaly_check}
        setFapar_anomaly_check={setFapar_anomaly_check}
        setFapar_anomaly_legend_url={setFapar_anomaly_legend_url}
        fapar_absorbed_check={fapar_absorbed_check}
        setFapar_absorbed_check={setFapar_absorbed_check}
        base_url={base_url}
        current_fapar_absorbed={current_fapar_absorbed}
        setCurrent_fapar_absorbed={setCurrent_fapar_absorbed}
        setFapar_absorbed_legend_url={setFapar_absorbed_legend_url}
        setCurrent_monthly_precipitation_gpcc={
          setCurrent_monthly_precipitation_gpcc
        }
        current_monthly_precipitation_gpcc={current_monthly_precipitation_gpcc}
        monthly_precipitation_check={monthly_precipitation_check}
        setMonthly_recipitation_check={setMonthly_recipitation_check}
        setGpcc_monthly_precipitation_legend_url={
          setGpcc_monthly_precipitation_legend_url
        }
        selected_region={selected_region}
        setSelected_region={setSelected_region}
        setCurrent_sma={setCurrent_sma}
        current_sma={current_sma}
        sma_check={sma_check}
        setSma_check={setSma_check}
        setLegend_url_sma={setLegend_url_sma}
        setCurrent_cdi={setCurrent_cdi}
        cdi_check={cdi_check}
        setCdi_check={setCdi_check}
        current_cdi={current_cdi}
        cdi_selected_dates={cdi_selected_dates}
        setCdi_selected_dates={setCdi_selected_dates}
        request_str_modis_ndvi={request_str_modis_ndvi}
        setRequest_str_modis_ndvi={setRequest_str_modis_ndvi}
        setCurrent_ndvi={setCurrent_ndvi}
        ndvi_check={ndvi_check}
        setNdvi_check={setNdvi_check}
        koppen_climate_clas_check={koppen_climate_clas_check}
        setKoppen_climate_clas_check={setKoppen_climate_clas_check}
        active_admin_boundaries={active_admin_boundaries}
        setActive_admin_boundaries={setActive_admin_boundaries}
        current_protected_areas={current_protected_areas}
        setCurrent_protected_areas={setCurrent_protected_areas}
        protetect_areas_check={protetect_areas_check}
        setProtetect_areas_check={setProtetect_areas_check}
        unwdc_check={unwdc_check}
        setUnwdc_check={setUnwdc_check}
        setCurrent_unwdc={setCurrent_unwdc}

        setUnwdc_legend_url={setUnwdc_legend_url}
        setCurrent_spi_era5={setCurrent_spi_era5}
        checked_spi_era5={checked_spi_era5}
        setChecked_spi_era5={setChecked_spi_era5}
        setCurrent_cdi_era5={setCurrent_cdi_era5}
        cdi_era5_check={cdi_era5_check} 
        setCdi_era5_check={setCdi_era5_check}
        longrange_forecast_check={longrange_forecast_check}
        setLongrange_forecast_check={setLongrange_forecast_check}
        setCurrent_longrange_forecast={setCurrent_longrange_forecast}
        drought_persistence_check={drought_persistence_check}
        setDrought_persistence_check={setDrought_persistence_check}
        setCurrent_drought_persistence={setCurrent_drought_persistence}
        combined_hazard_era5_check={combined_hazard_era5_check}
        setCombined_hazard_era5_check={setCombined_hazard_era5_check}
        setCurrent_combined_hazard_era5={setCurrent_combined_hazard_era5}
        combined_hazard_gpcc_check={combined_hazard_gpcc_check}
        setCombined_hazard_gpcc_check={setCombined_hazard_gpcc_check}
        setCurrent_combined_hazard_gpcc={setCurrent_combined_hazard_gpcc}
        combined_forecast_era5_check={combined_forecast_era5_check}
        setCombined_forecast_era5_check={setCombined_forecast_era5_check}
        setCurrent_combined_forecast_era5={setCurrent_combined_forecast_era5}
        combined_forecast_gpcc_check={combined_forecast_gpcc_check}
        setCombined_forecast_gpcc_check={setCombined_forecast_gpcc_check}
        setCurrent_combined_forecast_gpcc={setCurrent_combined_forecast_gpcc}

      />

      <Map
        selected_country={selected_country}
        precipitation_check={precipitation_check}
        current_vector={current_vector}
        current_spi={current_spi}
        current_fapar_anomaly={current_fapar_anomaly}
        fapar_anomaly_check={fapar_anomaly_check}
        current_fapar_absorbed={current_fapar_absorbed}
        fapar_absorbed_check={fapar_absorbed_check}
        current_monthly_precipitation_gpcc={current_monthly_precipitation_gpcc}
        monthly_precipitation_check={monthly_precipitation_check}
        current_sma={current_sma}
        sma_check={sma_check}
        cdi_check={cdi_check}
        current_cdi={current_cdi}
        cdi_selected_dates={cdi_selected_dates}
        current_ndvi={current_ndvi}
        ndvi_check={ndvi_check}
        koppen_climate_clas_check={koppen_climate_clas_check}
        koppen_climate_url={koppen_climate_url}
        active_admin_boundaries={active_admin_boundaries}
        current_protected_areas={current_protected_areas}
        protetect_areas_check={protetect_areas_check}
        clicked_latlong={clicked_latlong} 
        setClicked_latlong={setClicked_latlong}
        pixelDataFetched={pixelDataFetched} 
        setPixelDataFetched={setPixelDataFetched}
        setActive_tab={setActive_tab}
        admin_details={admin_details}
        show_generate_report={show_generate_report}
        setShow_generate_report={setShow_generate_report}
        current_unwdc={current_unwdc}
        unwdc_check={unwdc_check}
        checked_spi_era5={checked_spi_era5}
        current_spi_era5={spi_era5_current}
        cdi_era5_check={cdi_era5_check}
        current_cdi_era5={current_cdi_era5}
        longrange_forecast_check={longrange_forecast_check}
        current_longrange_forecast={current_longrange_forecast}
        drought_persistence_check={drought_persistence_check}
        current_drought_persistence={current_drought_persistence}
        combined_hazard_era5_check={combined_hazard_era5_check}
        current_combined_hazard_era5={current_combined_hazard_era5}
        combined_hazard_gpcc_check={combined_hazard_gpcc_check}
        current_combined_hazard_gpcc={current_combined_hazard_gpcc}
        combined_forecast_era5_check={combined_forecast_era5_check}
        current_combined_forecast_era5={current_combined_forecast_era5}
        combined_forecast_gpcc_check={combined_forecast_gpcc_check}
        current_combined_forecast_gpcc={current_combined_forecast_gpcc}
        layerOpacity={layerOpacity}
      />

      <RightBar
        rightBarOpen={rightBarOpen}
        setRightBarOpen={setRightBarOpen}
        spi_legend_url={spi_legend_url}
        Legend={Legend}
        precipitation_check={precipitation_check}
        fapar_anomaly_check={fapar_anomaly_check}
        fapar_anomaly_legend_url={fapar_anomaly_legend_url}
        fapar_absorbed_check={fapar_absorbed_check}
        fapar_absorbed_legend_url={fapar_absorbed_legend_url}
        monthly_precipitation_check={monthly_precipitation_check}
        gpcc_monthly_precipitation_legend_url={
          gpcc_monthly_precipitation_legend_url
        }
        sma_check={sma_check}
        legend_url_sma={legend_url_sma}
        cdi_check={cdi_check}
        ndvi_check={ndvi_check}
        koppen_climate_clas_check={koppen_climate_clas_check}
        koppen_climate_url={koppen_climate_url}
        active_tab={active_tab}
        setActive_tab={setActive_tab}
        cdi_selected_dates={cdi_selected_dates}
        clicked_latlong={clicked_latlong}
        pixelDataFetched = {pixelDataFetched}
        setAdmin_details={setAdmin_details}
        setShow_generate_report={setShow_generate_report}
        unwdc_check={unwdc_check}
        checked_spi_era5={checked_spi_era5}
        cdi_era5_check={cdi_era5_check}
        longrange_forecast_check={longrange_forecast_check}
        drought_persistence_check={drought_persistence_check}
        combined_hazard_era5_check={combined_hazard_era5_check}
        combined_hazard_gpcc_check={combined_hazard_gpcc_check}
        combined_forecast_era5_check={combined_forecast_era5_check}
        combined_forecast_gpcc_check={combined_forecast_gpcc_check}
        layerOpacity={layerOpacity}
        onOpacityChange={handleOpacityChange}
      />
      <FooterGeoportal lastUpdated={{year: year, lastUpdated: lastUpdated}} />
    </div>
  );
};

export default Geoportal;
